import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { Typography } from "../../Styles/GlobalStyles/Variables"
import { colors } from "../../Styles/GlobalStyles/Variables";
import LoadingButton from '@mui/lab/LoadingButton';

export const GreenButton = styled(Button)(({ theme }) => ({
    color: colors.white,
    backgroundColor: colors.primaryGreen ,
    textTransform: "inherit",
    // padding: theme.spacing(2),
    fontFamily: Typography.primaryFont,
    "&:hover": {
      backgroundColor: colors.darkGreen,
    },
   
  }));


   export const CustomGreenButton = styled(LoadingButton)(({ theme }) => ({
    color: colors.white,
    backgroundColor: colors.primaryGreen ,
    textTransform: "inherit",
    // padding: theme.spacing(2),
    fontFamily: Typography.secondaryFont,
    "&:hover": {
      backgroundColor: colors.darkGreen,
    },
   
  }));

  export const LighterGreenButton = styled(LoadingButton)(({ theme }) => ({
    color: colors.white,
    backgroundColor: colors.lighterGreen ,
    textTransform: "inherit",
    // padding: theme.spacing(2),
    fontFamily: Typography.secondaryFont,
    "&:hover": {
      backgroundColor: colors.darkGreen,
    },
   
  }));

  export const ElevatedGreenButton = styled(Button)(({theme})=>({
      textTransform: "capitalize",
      fontSize: "13px",
      padding:theme.spacing(1),
      margin: "10px 10px 10px 30px",
      backgroundColor: " rgba(1, 108, 52, 0.82)",
      boxShadow: '0px 4px 21px rgba(107, 169, 137, 0.48)',
      color: "#fff",
      "&:hover": { backgroundColor: "#016c34", boxShadow:'none' },
  }));


  export const GreyOutlinedButton = styled(Button)(({ theme }) => ({
    color: colors.primaryGrey,
    backgroundColor: "transparent" ,
    textTransform: "inherit",
    padding:'5px 20px',
    border:` 1px solid ${colors.primaryGrey} `,
    fontFamily: Typography.primaryFont,
    "&:hover": {
      backgroundColor: "transparent",
    },
   
  }));

  export const DialogGreyOutlinedButton = styled(Button)(({theme})=>({
    textTransform: "capitalize",
    fontSize: "13px",
    padding:theme.spacing(1),
    margin: "10px 10px 10px 30px",
    backgroundColor: "transparent" ,
    border:` 1px solid ${colors.primaryGrey} `,
    color: colors.primaryGrey,
    "&:hover": {
      backgroundColor: "transparent",
    },
}));
 

  export const GreyFilledButton = styled(Button)(({ theme }) => ({
    color: colors.primaryGrey,
    backgroundColor:  "#e5e5e5",
    textTransform: "inherit",
    padding:'5px 20px',
    fontFamily: Typography.primaryFont,
    "&:hover": {
      backgroundColor:  "#d5d5d5",
    },
   
  }));
 
  export const DialogButton = styled(LoadingButton)(({ theme }) => ({
    color: colors.white,
    backgroundColor: colors.primaryGreen ,
    textTransform: "inherit",
    // padding: theme.spacing(2),
    fontFamily: Typography.primaryFont,
    "&:hover": {
      backgroundColor: colors.darkGreen,
    },
   
  }));